import { PublicSettings } from '@/interfaces/publicSettings';

let defaultLanguage = 'fr';
let supportedLanguages: string[] = ['fr', 'en', 'pt'];

export const initLanguageConfig = (settings: PublicSettings) => {
  defaultLanguage = settings.bankInfo.defaultLanguage || 'fr';
  supportedLanguages = settings.supportedLanguages?.length ? settings.supportedLanguages : ['fr', 'en', 'pt'];
};

export const getDefaultLanguage = (): string => defaultLanguage;
export const getSupportedLanguages = (): string[] => supportedLanguages;
